
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    labels: { type: Array, default: () => [] },
    kunjungan: { type: Array, default: () => [] },
    orang: { type: Array, default: () => [] }
  },
  computed: {
    chartData() {
      return {
        labels: this.labels,
        datasets: [
          {
            label: "Kunjungan",
            data: this.kunjungan,
            borderColor: "#1976D2",
            backgroundColor: "#1976D2",
            pointRadius: 3,
            borderWidth: 2,
            fill: false,
            lineTension: 0
          },
          {
            label: "Jumlah orang",
            data: this.orang,
            borderColor: "#FB8C00",
            backgroundColor: "#FB8C00",
            pointRadius: 3,
            borderWidth: 2,
            borderDash: [6, 4],
            fill: false,
            lineTension: 0
          }
        ]
      };
    }
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { position: "bottom" },
        scales: {
          xAxes: [{ id: "tren-x", ticks: { autoSkip: true, maxRotation: 0 } }],
          yAxes: [
            {
              id: "tren-y",
              ticks: { beginAtZero: true, precision: 0 }
            }
          ]
        },
        tooltips: { mode: "index", intersect: false }
      }
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.renderChart(this.chartData, this.options);
      }
    }
  }
};
